import clsx from 'clsx';
import { FC } from 'react';

import { TeamMatchType } from '../../../types/match';

import { Match } from './Match';
import styles from './MatchList.module.scss';

type MatchListProps = {
  matches: TeamMatchType[];
  description?: string[];
  expandable?: boolean;
  fullName?: boolean;
  className?: string;
  matchClassName?: string;
};

export const MatchList: FC<MatchListProps> = ({
  matches,
  description,
  expandable,
  fullName,
  className,
  matchClassName,
}) => {
  return (
    <ul className={clsx(styles.list, className)}>
      {matches.map((match) => (
        <li key={`${match.team1.name}${match.score1}${match.team2.name}${match.score1}`}>
          <Match
            {...match}
            className={matchClassName}
            description={description}
            expandable={expandable && !!match.matches?.length}
            fullName={fullName}
          />
        </li>
      ))}
    </ul>
  );
};
